import React from 'react'
import { Link } from 'react-router-dom'
import { Instagram, Linkedin, Mail, Phone, MapPin, Heart } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  // SEO link-hub: linkt de belangrijkste landingspagina's vanaf elke pagina-footer.
  // Versterkt interne linking zodat Google deze pagina's prioriteert voor indexering.
  // NB: <a href> (geen <Link>) — dit zijn statische, door nginx geserveerde HTML-pagina's.
  const linkHub = [
    {
      title: 'UGC per branche',
      links: [
        { href: '/ugc-voor-webshops', label: 'Webshops' },
        { href: '/ugc-voor-restaurants', label: 'Restaurants' },
        { href: '/ugc-voor-beauty-merken', label: 'Beauty merken' },
        { href: '/ugc-voor-fitness', label: 'Fitness' },
        { href: '/ugc-voor-mode', label: 'Mode' },
        { href: '/ugc-voor-tech', label: 'Tech & SaaS' },
        { href: '/ugc-voor-horeca', label: 'Horeca' },
        { href: '/ugc-voor-reisbranche', label: 'Reisbranche' },
        { href: '/ugc-voor-vastgoed', label: 'Vastgoed' },
        { href: '/ugc-voor-huisdieren', label: 'Huisdieren' },
        { href: '/ugc-voor-coaches-dienstverleners', label: 'Coaches' },
        { href: '/ugc-voor-salons-wellness', label: 'Salons & Wellness' },
        { href: '/ugc-b2b', label: 'B2B' },
      ],
    },
    {
      title: 'Video laten maken',
      links: [
        { href: '/product-video-laten-maken', label: 'Productvideo' },
        { href: '/advertentie-video-laten-maken', label: 'Advertentievideo' },
        { href: '/testimonial-video-laten-maken', label: 'Testimonialvideo' },
        { href: '/explainer-video-laten-maken', label: 'Explainervideo' },
        { href: '/professionele-video-laten-maken', label: 'Professionele video' },
        { href: '/social-media-content-laten-maken', label: 'Social media content' },
        { href: '/voor-bedrijven', label: 'UGC laten maken' },
        { href: '/video-ugc', label: 'Video UGC' },
      ],
    },
    {
      title: 'Social media uitbesteden',
      links: [
        { href: '/social-media-uitbesteden', label: 'Social media uitbesteden' },
        { href: '/social-media-beheer-uitbesteden', label: 'Social media beheer' },
        { href: '/social-media-marketing-uitbesteden', label: 'Social media marketing' },
        { href: '/social-media-adverteren-uitbesteden', label: 'Adverteren uitbesteden' },
        { href: '/ugc-campagne-opzetten', label: 'Campagne opzetten' },
        { href: '/ugc-marketing-strategie', label: 'Marketingstrategie' },
      ],
    },
    {
      title: 'Voor creators',
      links: [
        { href: '/ugc-creator-worden', label: 'Creator worden' },
        { href: '/ugc-als-bijbaan', label: 'UGC als bijbaan' },
        { href: '/ugc-briefing-schrijven', label: 'Briefing schrijven' },
        { href: '/ugc-script-schrijven', label: 'Script schrijven' },
        { href: '/ugc-portfolio-opbouwen', label: 'Portfolio opbouwen' },
        { href: '/ugc-video-maken-smartphone', label: 'Filmen met smartphone' },
        { href: '/ugc-creator-vacature', label: 'Vacatures' },
        { href: '/ugc-rechten-licenties', label: 'Rechten & licenties' },
      ],
    },
    {
      title: 'UGC per stad',
      links: [
        { href: '/ugc-creator-amsterdam', label: 'Amsterdam' },
        { href: '/ugc-creator-rotterdam', label: 'Rotterdam' },
        { href: '/ugc-creator-den-haag', label: 'Den Haag' },
        { href: '/ugc-creator-utrecht', label: 'Utrecht' },
        { href: '/ugc-creator-eindhoven', label: 'Eindhoven' },
        { href: '/ugc-creator-nederland', label: 'Heel Nederland' },
      ],
    },
    {
      title: 'Vergelijken & meer',
      links: [
        { href: '/ugc4you-vs-influee', label: 'UGC4you vs Influee' },
        { href: '/ugc4you-vs-speekly', label: 'UGC4you vs Speekly' },
        { href: '/ugc4you-vs-hyred', label: 'UGC4you vs Hyred' },
        { href: '/ugc-platform-vergelijken', label: 'Platforms vergelijken' },
        { href: '/wat-kost-ugc-creator-nederland', label: 'Wat kost een creator?' },
        { href: '/ai-ugc-video-tools', label: 'AI UGC tools' },
        { href: '/over-ons', label: 'Over ons' },
        { href: '/partners', label: 'Partners' },
      ],
    },
  ]

  return (
    <footer className="relative mt-16">
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-400/5 to-purple-600/5 rounded-t-3xl blur-xl"></div>
      <div className="relative max-w-7xl mx-auto px-6 py-16 rounded-t-3xl bg-gradient-to-br from-neutral-900/80 to-neutral-800/80 border-t border-black/10 backdrop-blur">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand & Description */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-black tracking-tighter">
                UGC<span className="text-emerald-400">4you</span>
              </span>
            </Link>
            <p className="text-white/60 text-sm mb-6">
              Het platform dat merken verbindt met getalenteerde UGC creators in Nederland.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/ugc4you.nl/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-black/5 rounded-full flex items-center justify-center hover:bg-pink-400/20 hover:text-pink-400 transition group">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/ugc4you/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-black/5 rounded-full flex items-center justify-center hover:bg-emerald-400/20 hover:text-emerald-400 transition group">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* For Companies */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Voor Bedrijven</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/projects/create" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Opdracht Plaatsen
                </Link>
              </li>
              <li>
                <Link to="/creators" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Zoek Creators
                </Link>
              </li>
              <li>
                <a href="/content-creator-inhuren" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Content Creator Inhuren
                </a>
              </li>
              <li>
                <a href="/ugc-bureau" className="text-white/60 hover:text-emerald-400 transition-colors">
                  UGC Bureau
                </a>
              </li>
              <li>
                <a href="/ugc-prijzen" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Prijzen
                </a>
              </li>
              <li>
                <a href="/wat-is-ugc" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Wat is UGC?
                </a>
              </li>
            </ul>
          </div>

          {/* For Creators */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Voor Creators</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/projects" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Vind Opdrachten
                </Link>
              </li>
              <li>
                <a href="/ugc-content-creators" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Word Creator
                </a>
              </li>
              <li>
                <a href="/ugc-tips-creators" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Tips voor Creators
                </a>
              </li>
              <li>
                <a href="/ugc-trends-2026" className="text-white/60 hover:text-emerald-400 transition-colors">
                  UGC Trends
                </a>
              </li>
            </ul>
          </div>

          {/* Support & Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Support & Info</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="mailto:info@ugc4you.nl" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="/ugc-voorbeelden" className="text-white/60 hover:text-emerald-400 transition-colors">
                  UGC Voorbeelden
                </a>
              </li>
              <li>
                <a href="/ugc-marketing-strategie" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Marketing Strategie
                </a>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/algemene-voorwaarden" className="text-white/60 hover:text-emerald-400 transition-colors">
                  Algemene Voorwaarden
                </Link>
              </li>
            </ul>

            <div className="mt-6">
              <h4 className="font-medium mb-3 text-white">Contact</h4>
              <div className="space-y-2 text-sm text-white/60">
                <a href="mailto:info@ugc4you.nl" className="flex items-center hover:text-emerald-400 transition-colors">
                  <Mail className="w-4 h-4 mr-2 text-emerald-400" />
                  info@ugc4you.nl
                </a>
                <a href="tel:+31201234567" className="flex items-center hover:text-purple-400 transition-colors">
                  <Phone className="w-4 h-4 mr-2 text-purple-400" />
                  +31 (0)20 123 4567
                </a>
                <div className="flex items-center">
                  <MapPin className="w-4 h-4 mr-2 text-pink-400" />
                  Amsterdam, Nederland
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SEO Link Hub - belangrijke landingspagina's voor interne linking */}
        <div className="border-t border-black/10 mt-12 pt-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-8">
            {linkHub.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold mb-3 text-white">{col.title}</h4>
                <ul className="space-y-2 text-sm">
                  {col.links.map((l) => (
                    <li key={l.href}>
                      <a href={l.href} className="text-white/50 hover:text-emerald-400 transition-colors">
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-black/10 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <div className="text-sm text-white/50 mb-4 sm:mb-0">
            © {currentYear} UGC4you. Alle rechten voorbehouden.
          </div>

          <div className="flex items-center text-sm text-white/50">
            <span>Gemaakt met</span>
            <Heart className="w-4 h-4 mx-2 text-red-400 fill-current" />
            <span>in Nederland</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer